(function () {
  let swiperInstance = null;

  function initSwiper() {
    if (window.innerWidth < 1000 && !swiperInstance) {
      swiperInstance = new Swiper('.as-seen-in__grid', {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    } else if (window.innerWidth >= 1000 && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  initSwiper();
  window.addEventListener('resize', initSwiper);
})();
